import { IColumn } from "@fluentui/react";
import strings from "../../loc/strings";

export enum Tab {
    Normal = "0",
    Historical = "1"
}

export enum ColumnFieldName {
    FileName = "fileName",
    Actor = "actor",
    UploadDateTime = "uploadDate",
    ImportMechanism = "importMechanism",
    UploadStatus = "uploadStatus",
    NumberOfImpactedIdsInCsv = "impactedIds",
    TotalNumberOfFailedValidationRules = "failedValidationRules",
    Actions = "actions",
}

export const _listOfFilesUploadedColumns: IColumn[] = [
    {
        key: "FileName",
        name: strings.fileNameLabel,
        fieldName: ColumnFieldName.FileName,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "Actor",
        name: strings.actorLabel,
        fieldName: ColumnFieldName.Actor,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "UploadDate",
        name: strings.uploadDateTimeLabel,
        fieldName: ColumnFieldName.UploadDateTime,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        isSorted: true,
        isSortedDescending: true
    },
    {
        key: "ImportMechanism",
        name: strings.importMechanismLabel,
        fieldName: ColumnFieldName.ImportMechanism,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "UploadStatus",
        name: strings.uploadStatusLabel,
        fieldName: ColumnFieldName.UploadStatus,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "ImpactedIds",
        name: strings.numberOfImpactedIdsInCsvLabel,
        fieldName: ColumnFieldName.NumberOfImpactedIdsInCsv,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "FailedValidationRules",
        name: strings.totalNumberOfFailedValidationRulesLabel,
        fieldName: ColumnFieldName.TotalNumberOfFailedValidationRules,
        minWidth: 100,
        isResizable: true,
    },
    {
        key: "Actions",
        name: strings.actionsLabel,
        fieldName: ColumnFieldName.Actions,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
];